import { gql } from "@apollo/client";

export const EMAIL_CANCEL = gql`
  mutation emailCancel($id: Int!) {
    emailCancel(id: $id) {
      id
      message
      isError
    }
  }
`;
